import { cn as e } from "../../lib/utils.js";
import t from "../../_virtual/_@oxc-project_runtime@0.142.0/helpers/esm/objectSpread2.js";
import n from "../../node_modules/.pnpm/country-flag-icons@1.6.20/node_modules/country-flag-icons/modules/hasFlag.js";
import r from "../../node_modules/.pnpm/country-flag-icons@1.6.20/node_modules/country-flag-icons/modules/react/3x2/index.js";
import { _3x2_exports as i } from "../../node_modules/.pnpm/country-flag-icons@1.6.20/node_modules/country-flag-icons/react/3x2/index.js";
import * as a from "react";
import { jsx as o } from "react/jsx-runtime";
//#region src/components/composed/country-flag.tsx
var s, c = {
	sm: {
		width: 21,
		height: 15
	},
	md: {
		width: 28,
		height: 20
	},
	lg: {
		width: 35,
		height: 25
	}
}, l = (s = r) == null ? i : s, u = a.forwardRef(({ countryCode: r, languageCode: i, size: a = "md", className: s, style: u, "aria-label": d }, f) => {
	var p, m;
	let h = r == null ? i : r, g = (p = h == null ? void 0 : h.trim().toUpperCase()) == null ? "" : p, _ = r === void 0 ? (m = i == null ? void 0 : i.trim()) == null ? "" : m : g, v = n(g) ? l[g] : void 0, y = typeof a == "number" ? {
		width: a * 1.4,
		height: a
	} : c[a];
	return /* @__PURE__ */ o("span", {
		ref: f,
		role: "img",
		"aria-label": d || (_ ? `${_} flag` : "Flag"),
		className: e("inline-flex shrink-0 items-center justify-center overflow-hidden rounded-[2px]", s),
		style: t(t({}, y), u),
		children: v ? /* @__PURE__ */ o(v, {
			"aria-hidden": "true",
			className: "block size-full",
			focusable: "false"
		}) : /* @__PURE__ */ o("span", {
			"aria-hidden": "true",
			children: "🏳️"
		})
	});
});
u.displayName = "CountryFlag";
//#endregion
export { u as CountryFlag };

//# sourceMappingURL=country-flag.js.map